const PAYPAL_CLIENT_ID = process.env.PAYPAL_CLIENT_ID || '';

export { PAYPAL_CLIENT_ID };
